module.exports = __webpack_public_path__ + "static/media/logo.f9776f55.svg";